import React from "react";

import Sidebar from "~/components/ArticleSidebar";

import useGlobalCtas from "~/hooks/utils/useGlobalCtas";
import { createCTAPriorityList } from "../utils";

const ArticleSidebar = ({ data }) => {
    const {
        wp: { optionsPage },
        wpArticle: {
            productLines,
            productCategories,
            ctaSections: ctaSectionsOverride,
        },
    } = data;

    const ctaOverrides = ctaSectionsOverride?.sections;

    const priorityList = createCTAPriorityList(
        productLines?.nodes,
        productCategories?.nodes,
    );

    const ctaToUse = useGlobalCtas(priorityList, ctaOverrides);

    const globalOptions = optionsPage?.globalOptions;
    const hideKcTwitter = globalOptions?.hideTwitter?.hideKcTwitter;

    return <Sidebar {...{ ctas: ctaToUse }} hideTwitter={hideKcTwitter} />;
};

export default ArticleSidebar;
